<script setup>
import { onMounted, ref } from "vue";

const props = defineProps({
  groupid: Number,
});

const containerId = `vk_groups_${props.groupid}`;
const ready = ref(false);

function initWidget() {
  if (typeof VK === 'undefined' || !props.groupid) return;
  ready.value = true;
  VK.Widgets.Group(
    containerId,
    { mode: 0, width: "auto", no_cover: 1, wide: 1, color1: "FFFFFF", color2: "000000", color3: "5181B8" },
    props.groupid
  );
}

onMounted(() => {
  if (!props.groupid) return;

  if (typeof VK !== 'undefined') {
    initWidget();
    return;
  }

  // Грузим скрипт VK лениво — только когда виджет реально нужен
  const existing = document.querySelector('script[src*="vk.com/js/api/openapi.js"]');
  if (existing) {
    existing.addEventListener('load', initWidget);
  } else {
    const s = document.createElement('script');
    s.src = 'https://vk.com/js/api/openapi.js?169';
    s.async = true;
    s.onload = initWidget;
    document.head.appendChild(s);
  }
});
</script>

<template>
  <div v-if="ready" :id="containerId"></div>
  <div v-else class="text-sm text-gray-500 py-2">ВКонтакте виджет доступен на сайте</div>
</template>



